import styled from 'styled-components';

export const ScTerms = styled.div`
  max-width: 830px;
  width: 100%;
  margin-inline: auto;
  min-height: 100px;

  & .answer {
    & ul,
    & ol {
      padding-left: 24px;
      padding-bottom: 16px;
      & li {
        counter-increment: list-0;
        counter-reset: list-1 list-2 list-3;
        line-height: 28px;

        &.ql-indent-1 {
          padding-left: 20px;
          counter-increment: list-1;
          counter-reset: list-2;
          list-style-type: none;

          &:before {
            content: counter(list-1, lower-alpha) ') ';
          }
        }

        &.ql-indent-2 {
          padding-left: 40px;
          counter-increment: list-2;
          counter-reset: list-3;
          list-style-type: none;

          &:before {
            content: counter(list-2, lower-roman) '. ';
          }
        }
      }
    }
  }
`;
